import type { Board, Coord } from "~/types";

export const shuffle = <T>(array: T[], rng: () => number = Math.random) => {
  let currentIndex = array.length;
  let randomIndex: number;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    randomIndex = Math.floor(rng() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

export const shuffleBoard = (board: Board, oldCoords: Coord[], newCoords: Coord[]) => {
  const tempBoard = board.map(col => col.map(tile => tile));
  oldCoords.forEach((coord, i) => {
    const newCoord = newCoords[i];
    const tmp = tempBoard[coord[0]][coord[1]];
    tempBoard[coord[0]][coord[1]] = tempBoard[newCoord[0]][newCoord[1]];
    tempBoard[newCoord[0]][newCoord[1]] = tmp;
  });
  return tempBoard;
}